import { CloudOff, X } from "lucide-react";
import { getDeviceId } from "@/lib/offlineDraft";

const STALE_DAYS = 14;

function isStale(lastSeen) {
    if (!lastSeen) return false;
    return Date.now() - new Date(lastSeen).getTime() > STALE_DAYS * 24 * 60 * 60 * 1000;
}

// Shows "N photos still waiting on X's phone" for every OTHER device with photos
// still queued for this record (server-reported via that record's pending_uploads
// map), flags anything older than 14 days as stale, and lets anyone with edit
// rights on the record clear a stuck entry (e.g. the device was lost/reset and
// will never come back online to finish syncing).
export function OtherDevicePendingBanner({ pendingUploads, canClear, onClear, testIdPrefix = "pending-uploads-banner" }) {
    const entries = Object.entries(pendingUploads || {}).filter(([devId]) => devId !== getDeviceId());
    if (!entries.length) return null;
    return (
        <>
            {entries.map(([devId, info]) => {
                const stale = isStale(info.last_seen);
                return (
                    <div key={devId} data-testid={`${testIdPrefix}-${devId}`}
                        className="flex items-center gap-2.5 rounded-xl px-4 py-3 border" style={{ background: "#F0EDE8", borderColor: "#E5E0DA" }}>
                        <CloudOff size={16} className="text-[#6F6A64] shrink-0" />
                        <p className="text-[12.5px] text-[#4A4642] flex-1">
                            {info.count} photo{info.count !== 1 ? "s" : ""} {info.count !== 1 ? "are" : "is"} still waiting to upload from {info.user_name ? `${info.user_name}'s` : "another"} device
                            {info.device_label ? ` (${info.device_label}` : ""}{info.last_seen ? `, last seen ${new Date(info.last_seen).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}` : ""}{info.device_label ? ")" : ""}.
                            {" "}They'll appear once that device opens this report with signal.
                            {stale && <span data-testid={`${testIdPrefix}-${devId}-stale`} className="ml-1.5 font-semibold text-[#9F4212]">· Stale (14+ days)</span>}
                        </p>
                        {canClear && (
                            <button type="button" data-testid={`${testIdPrefix}-${devId}-clear`}
                                onClick={() => { if (window.confirm("Clear this device's pending-upload entry? Only do this if the device is lost or will never come back online.")) onClear(devId); }}
                                className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#6F6A64] hover:text-[#B33A2E] shrink-0">
                                <X size={12} /> Clear
                            </button>
                        )}
                    </div>
                );
            })}
        </>
    );
}
